import React from 'react';
import { FadeIn } from '../components/FadeIn';
import { CtaButton } from '../components/CtaButton';
import { LockIcon, MailIcon, ShieldCheckIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToMechanism = () => {
    const el = document.getElementById('mechanism-section');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden px-6 py-16" data-id="element-225">
      {/* Breathing Background Animation */}
      <div className="absolute top-1/2 left-1/2 w-[600px] h-[600px] md:w-[800px] md:h-[800px] bg-lavender rounded-full blur-3xl animate-breathe pointer-events-none" data-id="element-226" />

      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-227">
        <FadeIn delay={0.1} data-id="element-228">
          <div className="inline-flex items-center px-4 py-1.5 rounded-full border border-rosegold/50 bg-midnight/50 backdrop-blur-sm mb-8" data-id="element-229">
            <span className="text-rosegold font-inter text-xs md:text-sm font-semibold uppercase tracking-wider" data-id="element-230">
              ⚡ Instant Access — Works in 55 Seconds
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-231">
          <h1 className="font-playfair text-4xl md:text-6xl lg:text-7xl font-bold text-warmwhite leading-tight mb-8" data-id="element-232">
            Your Body Is Still Burning.
            <br data-id="element-233" />
            <span className="text-rosegold" data-id="element-234">Your Mind Already Lost.</span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-235">
          <p className="font-inter text-lg md:text-xl text-lavender max-w-2xl mx-auto mb-12 leading-relaxed" data-id="element-236">
            The moment anger takes over — your heart races, your hands shake,
            and you say things you can't take back. What if you could stop all
            of it in 55 seconds — without meditating, without counting to ten,
            without leaving the room?
          </p>
        </FadeIn>

        <FadeIn delay={0.4} className="w-full flex flex-col items-center" data-id="element-237">
          <CtaButton text="Yes — I Want To Stop The Rage Instantly →" onClick={scrollToMechanism} className="mb-8 w-full md:w-auto md:min-w-[400px]" data-id="element-238" />

          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-3 font-inter text-sm md:text-base mt-2" data-id="element-239">
            <span className="flex items-center text-rosegold font-semibold drop-shadow-[0_0_12px_rgba(201,169,110,0.9)]" data-id="element-240">
              <LockIcon className="w-4 h-4 mr-2 text-rosegold" data-id="element-241" /> Secure Payment
            </span>
            <span className="text-rosegold/60 font-bold" data-id="element-242">•</span>
            <span className="flex items-center text-rosegold font-semibold drop-shadow-[0_0_12px_rgba(201,169,110,0.9)]" data-id="element-243">
              <MailIcon className="w-4 h-4 mr-2 text-rosegold" data-id="element-244" /> Instant Email
              Access
            </span>
            <span className="text-rosegold/60 font-bold" data-id="element-245">•</span>
            <span className="flex items-center text-rosegold font-semibold drop-shadow-[0_0_12px_rgba(201,169,110,0.9)]" data-id="element-246">
              <ShieldCheckIcon className="w-4 h-4 mr-2 text-rosegold" data-id="element-247" /> 7-Day
              Money Back Guarantee
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
}